// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602182040/js/" + chunkId + "." + {"44":"2d89f79e","225":"db73f042","481":"38f0e51d","486":"5a58aa21","770":"d8f81dc7"}[chunkId] + ".0.5993882096961929.chunk.js";
};